import { SvgProps } from "components/icons/types";

export const DocumentIcon = ({
  width = 16,
  height = 16,
  ...props
}: SvgProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 6H7.5V7H2.5V6ZM2.5 9H6V8H2.5V9ZM10 3.793V12H0V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0L6.207 0L10 3.793ZM6.5 3.5H8.293L6.5 1.707V3.5ZM9 11V4.5H5.5V1H1.5C1.36739 1 1.24021 1.05268 1.14645 1.14645C1.05268 1.24021 1 1.36739 1 1.5V11H9Z"
      fill="currentColor"
    />
  </svg>
);
